import React from 'react';
import FloatingWrapper from './FloatingWrapper';

interface FilterClearButtonProps {
  handleClick: () => void;
  isDesktop: boolean;
}

const FilterClearButton = (props: FilterClearButtonProps) => {
  return (
    <FloatingWrapper style={{ backgroundColor: '#FFF', padding: '5px', zIndex: 1 }} isDesktop={props.isDesktop}>
      <a style={{ color: '#000' }} onClick={() => props.handleClick()}>
        clear
      </a>
    </FloatingWrapper>
  );
};

export default FilterClearButton;
